import {
  fileMenuJson,
  fileRegistrationResultsJson,
  maintenanceJson,
} from "../../core/http/jsonClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { dataActions } from "./actions";

export function* dataSaga() {
  yield takeEveryFsa(dataActions.getMenus.started, function* (action) {
    yield* makeAsyncApiCall(action, dataActions.getMenus, fileMenuJson);
  });
  yield takeEveryFsa(
    dataActions.getMaintenanceJson.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        dataActions.getMaintenanceJson,
        maintenanceJson,
      );
    },
  );

  yield takeEveryFsa(
    dataActions.getRegistrationResults.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        dataActions.getRegistrationResults,
        fileRegistrationResultsJson,
      );
    },
  );
}
